import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export type { SolarPageData } from "./solar-stats.impl";

const solarPageSchema = z.object({
	page: z.number().int().min(1).default(1),
	pageSize: z.number().int().min(1).max(365).default(30),
	monthPage: z.number().int().min(1).default(1),
	monthPageSize: z.number().int().min(1).max(24).default(12),
});

export const getSolarDataPageFn = createServerFn({ method: "GET" })
	.inputValidator(solarPageSchema)
	.handler(async ({ data }) => {
		const { loadSolarPageData } = await import("@/server/solar-stats.impl");
		return loadSolarPageData(data);
	});

const rangeSchema = z.object({
	days: z.number().int().min(1).max(3650).default(365),
});

export const getSolarDataRangeFn = createServerFn({ method: "GET" })
	.inputValidator(rangeSchema)
	.handler(async ({ data }) => {
		const { getSolarDataRange } = await import("@/server/solar-stats.impl");
		return getSolarDataRange(data.days);
	});

export const ingestYesterdaySolarDataFn = createServerFn({
	method: "POST",
}).handler(async () => {
	const { ingestYesterdaySolarData } = await import(
		"@/server/solar-stats.impl"
	);
	return ingestYesterdaySolarData();
});
